import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectFileModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'fileId',
        'fileName',
        'selectButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          fileId: 'ファイルID',
          fileName: 'ファイル名',
          selectButton: ''
        },
        columnsClasses: {
          fileId: 'wp-5',
          fileName: '',
          selectButton: 'wp-5'
        },
        sortable: [
          'fileId',
          'fileName'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('ファイル'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      // model
      fileModel: state => state.selectFileModal.fileModel,
      serviceModel: state => state.selectFileModal.serviceModel,
      tenantModel: state => state.selectFileModal.tenantModel,
      // 検索
      filters: state => state.selectFileModal.filters,
      fileType: state => state.selectFileModal.fileType,

      serviceId: state => state.selectFileModal.serviceId,
      active: state => state.selectFileModal.active
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
    tenantList() {
      return this.tenantModel.map(item => {
        return {
          value: item.tenant.tenantUuid,
          label: item.tenant.name
        }
      })
    },

    // filter
    searchFileName: {
      get () {
        return this.filters.searchFileName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchFileName',
          value: value
        })
      }
    },
    searchTenant: {
      get () {
        return this.filters.searchTenant
      },
      set (value) {
        this.setInputFilter({
          key: 'searchTenant',
          value: value
        })
      }
    },
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectFileModal/loadModel',
      loadFileList: 'selectFileModal/loadFileList',
      hide: 'selectFileModal/hide',
      setValue: 'selectFileModal/setValue',
      reset: 'selectFileModal/reset'
    }),
    ...mapMutations({
      setInputFilter: 'selectFileModal/setInputFilter',
    }),

    init () {
      this.loading = true

      // storeをリセット
      this.reset()

      //
      let fileParams = {
        serviceUuid: this.serviceId
      }
      if (this.fileType !== '') {
        fileParams.contentType = this.fileType
      }
      console.log(fileParams)

      // データ読出し
      this.loadModel({
        fileParams: fileParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.fileModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    // 検索
    resetSearch () {
      this.searchFileName = null
      this.searchTenant = ''

      this.search()
    },
    search () {
      this.loading = true

      //
      let fileParams = {
        serviceUuid: this.serviceId
      }
      if (this.fileType !== '') {
        fileParams.contentType = this.fileType
      }
      if (this.searchFileName)
        fileParams.fileName = this.searchFileName
      if (this.searchTenant !== '')
        fileParams.tenantUuid = this.searchTenant
      console.log(fileParams);

      // データ読出し
      this.loadFileList({
        fileParams: fileParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.fileModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    selectItem (props) {
      // console.log(props.row)

      // 選択されたファイル情報をstoreに保持
      this.setValue(props.row)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}